import React from 'react';
import styled from 'styled-components';
import mediaBreakpoints from '../../../styles/media-breakpoints';
import styleUtils from '../../../styles/style.utils';
import ButtonsListItem from './buttons-list-item/buttons-list-item.container';
import { ButtonListDataItem } from '../buttons-list.data';

interface ButtonsListContentProps {
  items: ButtonListDataItem[];
}
const ButtonsListContent: React.FunctionComponent<ButtonsListContentProps> = ({
  items
}) => {
  return (
    <Container>
      {items.map((item) => (
        <ButtonsListItem key={`button-item-${item.id}`} item={item} />
      ))}
    </Container>
  );
};

const Container = styled.div`
  margin-top: ${styleUtils.px(19)};
  align-items: flex-start;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${mediaBreakpoints.greaterThan('M')`
    margin-top: ${styleUtils.px(28)};
    flex-direction: row;  
  `};
`;

export default ButtonsListContent;
